import { render, staticRenderFns } from "./locale_changer.vue?vue&type=template&id=615ad736&scoped=true"
import script from "./locale_changer.vue?vue&type=script&lang=js"
export * from "./locale_changer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ad736",
  null
  
)

export default component.exports